module.exports = __webpack_public_path__ + "img/noting.789444fe.png";